import { clx, DropdownList, DropdownListItem } from "@hm/fundamental"

import type { FilterOption } from "../../../model/types"

interface MultiselectDropdownProps {
	listboxId: string
	deferredQuery: string
	filteredOptions: FilterOption[]
	selectedValues: (string | number)[]
	onToggleValue: (value: string | number) => void
	"data-cy": string
}

export const MultiselectDropdown: React.FC<MultiselectDropdownProps> = ({
	listboxId,
	deferredQuery,
	filteredOptions,
	selectedValues,
	onToggleValue,
	"data-cy": dataCy,
}) => {
	return (
		<div
			id={listboxId}
			className={clx(
				"absolute z-50 mt-1 w-full max-h-[312px] overflow-y-auto rounded-lg",
				"border border-solid border-border",
				"bg-container_background_elevated",
				"shadow-user_menu",
			)}
			data-cy={`${dataCy}-dropdown`}
		>
			<DropdownList
				isOpen
				key={`${deferredQuery}-${selectedValues.join()}`}
			>
				{filteredOptions.map(option => (
					<DropdownListItem
						key={option.value}
						title={option.label}
						value={option.value}
						showCheckbox
						isSelected={selectedValues.includes(option.value)}
						onClick={() => onToggleValue(option.value)}
						icon={option.icon}
						iconClassName={option.iconClassName}
						titleClassName={option.titleClassName}
						data-cy={`${dataCy}-option-${option.value}`}
					/>
				))}
			</DropdownList>
		</div>
	)
}
